import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { MatchdayRoutingModule } from './matchday-routing.module';
import { MatchdayComponent } from './matchday/matchday.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MomentModule } from 'ngx-moment';
import { MatchdayProgramComponent } from './matchday-program/matchday-program.component';
import { TheCrossBarComponent } from './the-cross-bar/the-cross-bar.component';
import { PointtableComponent } from './pointtable/pointtable.component';


@NgModule({
  declarations: [MatchdayComponent, MatchdayProgramComponent, TheCrossBarComponent, PointtableComponent],
  imports: [
    CommonModule,
    MatchdayRoutingModule,
    FormsModule,
    SharedModule,
    MomentModule,
    SlickCarouselModule
  ]
})
export class MatchdayModule { }
